/** Tiered platform fee schedule — keep in sync with backend/billing.py */

export const PLATFORM_FEE_TIERS = [
    { upTo: 100, rate: 0.03, label: "3%" },
    { upTo: 500, rate: 0.02, label: "2%" },
    { upTo: 1000, rate: 0.0175, label: "1.75%" },
    { upTo: 5000, rate: 0.015, label: "1.5%" },
];

export const PLATFORM_FEE_TOP_RATE = 0.01;

export const PLATFORM_FEE_TIER_SUMMARY = [
    { range: "£0 – £99.99", rate: "3%" },
    { range: "£100 – £499.99", rate: "2%" },
    { range: "£500 – £999.99", rate: "1.75%" },
    { range: "£1,000 – £4,999.99", rate: "1.5%" },
    { range: "£5,000+", rate: "1%" },
];

/**
 * Progressive platform fee on gross transaction amount.
 * Thresholds use the same numeric values in the payment currency.
 */
export function calculatePlatformFee(amount) {
    const gross = Number(amount);
    if (!Number.isFinite(gross) || gross <= 0) return 0;

    let fee = 0;
    let lower = 0;
    for (const tier of PLATFORM_FEE_TIERS) {
        if (gross <= lower) break;
        const chunk = Math.min(gross, tier.upTo) - lower;
        fee += chunk * tier.rate;
        lower = tier.upTo;
    }
    if (gross > lower) {
        fee += (gross - lower) * PLATFORM_FEE_TOP_RATE;
    }
    return Math.round(fee * 100) / 100;
}

export function effectivePlatformFeeRate(amount) {
    const gross = Number(amount);
    if (!Number.isFinite(gross) || gross <= 0) return 0;
    return calculatePlatformFee(gross) / gross;
}

export function formatEffectiveFeePercent(amount) {
    const rate = effectivePlatformFeeRate(amount);
    if (!rate) return "0%";
    return `${(rate * 100).toFixed(rate >= 0.01 ? 1 : 2).replace(/\.0$/, "")}%`;
}
